export default __webpack_public_path__ + "static/media/Tooltip.a8b7d0fa.svg";